import React, { CSSProperties } from 'react';
import {
	AccessorKeyColumnDef,
	Column,
	flexRender,
	getCoreRowModel,
	useReactTable,
} from '@tanstack/react-table';
import { Table as BTable } from 'react-bootstrap';
import { ProgressCardDataEntry } from './ProgressOverview';

type Props = {
	data: ProgressCardDataEntry[];
	columns: AccessorKeyColumnDef<ProgressCardDataEntry, unknown>[];
};
const Table = ({ data, columns }: Props) => {
	const getCommonPinningStyles = (column: Column<ProgressCardDataEntry>): CSSProperties => {
		const isPinned = column.getIsPinned();
		return {
			left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
			right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
			opacity: isPinned ? 0.95 : 1,
			position: isPinned ? 'sticky' : 'relative',
			width: column.getSize(),
			zIndex: isPinned ? 1 : 0,
			textAlign: 'start'
		};
	};

	const table = useReactTable({
		data,
		columns,
		getCoreRowModel: getCoreRowModel(),
		enableGlobalFilter: true,
		initialState: {
			columnPinning: {
				left: ['label'],
			},
		},
	});
	return (
		<BTable responsive hover size={'l'}>
			<thead>
				{table.getHeaderGroups().map((headerGroup) => (
					<tr key={headerGroup.id}>
						{headerGroup.headers.map((header) => {
							return (
								<th
									key={header.id}
									className={'p-0 text-nowrap'}
									style={{ ...getCommonPinningStyles(header.column) }}>
									{header.isPlaceholder
										? null
										: flexRender(header.column.columnDef.header, header.getContext())}
								</th>
							);
						})}
					</tr>
				))}
			</thead>
			<tbody>
				{table.getRowModel().rows.map((row) => (
					<tr key={row.id}>
						{row.getVisibleCells().map((cell) => (
							<td
								key={cell.id}
								className={'p-0'}
								style={{ ...getCommonPinningStyles(cell.column) }}>
								{flexRender(cell.column.columnDef.cell, cell.getContext())}
							</td>
						))}
					</tr>
				))}
			</tbody>
		</BTable>
	);
};
export default Table;
